import * as React from 'react';
export const billieSvg = React.forwardRef(function billieSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.258 4.984c0 .622-.068 1.303-.197 1.94l.002-.003A5.098 5.098 0 0 1 14 10.906C14 13.714 11.697 16 8.869 16H2V5.094c0-1.4.588-2.754 1.614-3.712A5.129 5.129 0 0 1 7.458.01c2.645.166 4.8 2.397 4.8 4.974Zm-5.495 8.633h2.102a2.722 2.722 0 0 0 2.727-2.709A2.69 2.69 0 0 0 10.8 9c-.928 1.755-2.25 3.268-4.037 4.617ZM9.739 6.26c.066-.377.117-.825.117-1.277 0-1.34-1.143-2.504-2.548-2.591a2.712 2.712 0 0 0-2.044.73 2.678 2.678 0 0 0-.862 1.975V6.26h5.337Zm-.874 1.939H4.398v4.692c2.153-1.364 3.632-2.867 4.617-4.688-.05-.004-.1-.004-.15-.004Z',
    }),
  );
});
billieSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billie = {
  category: 'paymentmethod',
  colorable: true,
  name: 'billie',
  svg: billieSvg,
};
